import React from 'react'

const NewsletterSignUp = () => (
	<aside className="grow">
		<p className="h4">Newsletter Sign Up</p>

		<iframe
			src="/newsletter-signup"
			className="w-full min-h-[350px]"
		/>
	</aside>
)

export default NewsletterSignUp
